import DateUtils from '@date-io/moment';
import { Button, CircularProgress, createMuiTheme, CssBaseline, Typography, useMediaQuery } from '@material-ui/core';
import { teal, red, purple, deepOrange } from '@material-ui/core/colors';
import { createStyles, MuiThemeProvider, Theme, useTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import React, { useGlobal } from 'reactn';
import './css/App.css';
import initializeGlobalState, { IGlobalState } from './states/GlobalState';
import { OidcCallback } from './oidc-callback';
import { AuthDataType, getIdentityFromStorage, IAuth, retrieveAuthData } from './types/auth';
import { GetConfiguration } from './utils/config';
import IForfettariHomePage from './views/forfetari/IForfettariHomePage';
import IConvSrlHome from './views/SimulazioniSrl/iConvSrlHome';
import publicIp from "react-public-ip";
import ErrorBoundary from './errorBoundary';
// import '../node_modules/react-modal-video/css/modal-video.min.css';
import { LoggerServiceProvider } from './logger';
import CompanyIndex from './views/company/index';
import AgencyIndex from './views/agency';
import PrincipalIndex from './views/principal';
import { Principal } from './models/principal';
import { CompanyDetail } from './views/company/detail';
import { SnackbarProvider } from 'notistack';
import { SnackbarOrigin } from '@material-ui/core';
import { AgencyDetail } from './views/agency/detail';
import { PrincipalDetail } from './views/principal/detail';
import { breakpoint } from './types/constants';
import IBudgetHomePage from './views/SchedaBudget/IBudgetHomePage';
import DashboardView from './views/applicazione';
import { AnimatedRoutes, RouteTransition } from './animation/RoutTransition';
import WhatsNewIndex from './views/whatsNew';
import { WhatsNewDetail } from './views/whatsNew/detail';
import ImportTelematicoIndex from './views/importTelematico';
import ReportIndex from './views/report';

const theme = createMuiTheme({
  typography: {
    fontSize: 13,
    fontFamily: [
      '"Roboto Condensed"',
      'sans-serif'
    ].join(','),
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "1.2em",
        // backgroundColor: "red"
      }
    },
  },
  palette: {
    primary: {
      light: 'rgba(0, 161, 216, 0.8)', // blue[100],
      main: 'rgba(0, 161, 216, 1.0)',  // blue[500],
      dark: 'rgba(0, 161, 216, 1.0)', // blue[800],
      contrastText: '#fff',
    },
    secondary: {
      light: teal[100],
      main: teal[500],
      dark: teal[800],
      contrastText: '#fff',
    }
  }
});

const themeUnappa = createMuiTheme({
  typography: {
    fontSize: 13,
    fontFamily: [
      '"Roboto Condensed"',
      'sans-serif'
    ].join(','),
  },
  palette: {
    primary: {
      // light: 'rgba(240, 52, 52, 1)',
      // main: 'rgba(240, 52, 52, 1)',  
      // dark: 'rgba(240, 52, 52, 1)',
      light: red[300],
      main: red[500],
      dark: red[800],
      contrastText: '#fff',
    },
    secondary: {
      light: deepOrange[100],
      main: deepOrange[300],
      dark: deepOrange[800], 
      contrastText: '#fff',
    }
  }
});

function selectTheme(){
  var urlSplittato = window.location.href.split('/');
  if(urlSplittato[2].startsWith("Unappa")){   
    return themeUnappa;
  }
  else if (urlSplittato[2].startsWith("wki")){   
    return theme;
  }
  else {
    return theme;
  } 
}

const themeDaUsare = selectTheme();

export class App extends React.PureComponent<{}> {
  constructor() {
    super();
    const global = this.global as IGlobalState;
    initializeGlobalState(GetConfiguration().sviluppo/*, global*/);
  }

  componentDidMount() {
    const global = this.global as IGlobalState;
    console.log('Starting...', { global: this.global })
    
    publicIp.v4().then(myip => this.setGlobal({ ...global, ip : myip}));
    global.auth.userManager.getUser()
    .then(user => {
      if (user && !user.expired) {
        const authData = retrieveAuthData(user);
        console.log('InitialWait: getUser', { user, authData })
        this.setGlobal({ ...global, auth: { ...global.auth, user, authData }, loadingAuth: false, globalWait: false })
      } else {
        console.log('InitialWait: getUser -> NO USER', { user })
        this.setGlobal({ ...global, loadingAuth: false, globalWait: false })
      }
    })
    .catch(() => this.setGlobal({ ...global, globalWait: false, loadingAuth: true }))
  }
  
  render() {
    const global = this.global as IGlobalState;
    const { auth, loadingAuth } = global;

    return (
      <React.Fragment>
        <ErrorBoundary>
          {
            loadingAuth ? <InitialWait /> :
              auth ? <AppContinue auth={auth} /> : null
          }
          <GlobalWait />
        </ErrorBoundary>
      </React.Fragment>
    )
  }
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  globalWaitRoot: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    
    top: 0,
    // bottom: 0,
    left: 0,
    // right: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999,
    backgroundColor: '#c0c0c0',
    // backgroundColor: '#74706F' //Più scuro
    // backgroundColor: rgba(255, 255, 255, 0.7);
  },
  globalWaitSpinner: {
    margin: 'auto',
  },
  loginroot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  logincontent: {
    margin: 'auto',
    textAlign: 'center',
    fontSize: '36pt',
    border: 'solid 1px #c0c0c0',
    padding: 40,
    borderRadius: 10,
    backgroundColor: '#f0f0f0',
  },
}))

const GlobalWait = () => {
  const [globalWait,] = useGlobal<IGlobalState, 'globalWait'>('globalWait')
  const classes = useStyles();
  return (
    <React.Fragment>
      {globalWait
        ? <div className={classes.globalWaitRoot}><CircularProgress className={classes.globalWaitSpinner} /></div>
        : <div></div>}
    </React.Fragment>
  )
}

const InitialWait = () => {
  return (
    <React.Fragment>
      <div style={{ height: '100vh', width: '100vw', display: 'flex' }}>
        <Typography variant='h6' style={{ margin: 'auto' }}>Loading...</Typography>
      </div>
    </React.Fragment>
  )
}

const AppContinue = (props: { auth: IAuth }) => {
  const [identity,setIdentity] = useGlobal<IGlobalState, 'identity'>('identity');  
  const { auth } = props;
  
  const anchorOrigin: SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  }
    
  console.log('Sono in app continue ');
  
  let storIdentity = getIdentityFromStorage();
  if (storIdentity && !identity) {
    console.log('StorageIdentity in APP dal SSO is: ' + JSON.stringify(storIdentity));
    setIdentity(storIdentity as Principal);
  }
  
  return (
    <React.Fragment>
      <SnackbarProvider anchorOrigin={anchorOrigin}>
      <LoggerServiceProvider>
        <CssBaseline />
        <MuiThemeProvider theme={themeDaUsare}>
          <MuiPickersUtilsProvider utils={DateUtils}>
            {/*<Router basename={process.env.PUBLIC_URL}>
              </Router> */}
              {auth.user && identity 
                ? <Root auth={auth}/>
                : <LoggedOutRouting auth={auth}/>
              }
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </LoggerServiceProvider>
      </SnackbarProvider>    
    </React.Fragment>
  )
}

const Root = (props: { auth: IAuth }) => {
  const [, setProvincia] = useGlobal<IGlobalState, 'prov'>('prov');  
  const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');  
  
  const handleAuthDataLoaded = (authData: AuthDataType) => {
    console.log('AuthData Loaded - from Root', { authData })
    if (authData.provinciaDefault) {
      setProvincia(authData.provinciaDefault)
    }
  }
  const { auth } = props;

  return (
    <Router>
      <AnimatedRoutes exitBeforeEnter initial={false}>
        <RouteTransition path="/login" exact={true} >
          <PageLogin />
        </RouteTransition>
        <Route path="/callback" render={props => <OidcCallback {...props} onAuthDataLoaded={handleAuthDataLoaded} />} />
        <RouteTransition path="/company" exact={true}> 
          <CompanyIndex />
        </RouteTransition>
        <RouteTransition path="/agency" exact={true} >
          <AgencyIndex />
        </RouteTransition>
        <RouteTransition path="/principal" exact={true}>
          <PrincipalIndex />
        </RouteTransition>
        <RouteTransition path="/whatsnew" exact={true}>
          <WhatsNewIndex />
        </RouteTransition>
        <RouteTransition path="/importtelematico" exact={true}>
           <ImportTelematicoIndex /> 
        </RouteTransition>
        <RouteTransition path="/report" exact={true}>
           <ReportIndex /> 
        </RouteTransition>
        {/* <Route path="/" exact={true} component={HomeIndex} /> */}
        <RouteTransition path="/" exact={true} > 
          <DashboardView/>
        </RouteTransition>
        <RouteTransition path="/iforf" exact={true}>
          <IForfettariHomePage />
        </RouteTransition>  
        <RouteTransition path="/convsrl" exact={true}> 
          <IConvSrlHome /> 
        </RouteTransition>
        <RouteTransition path="/budget" exact={true}>
          <IBudgetHomePage /> 
        </RouteTransition> 
        <RouteTransition path="/companyDetail/:id" exact={true}> 
          <CompanyDetail /> 
        </RouteTransition>
        <RouteTransition path="/agencyDetail/:id" exact={true}>
           <AgencyDetail /> 
        </RouteTransition>
        <RouteTransition path="/principalDetail/:id" exact={true}>
           <PrincipalDetail /> 
        </RouteTransition>
        <RouteTransition path="/whatsNewDetail/:id" exact={true}>
           <WhatsNewDetail /> 
        </RouteTransition>
        {auth.user && identity ?
          <RouteTransition path="/" exact={true} > 
            <DashboardView /> 
          </RouteTransition>
        : null}
        {!auth.user ? (
          <Redirect to="/login"/>
        )
        :
        null 
        }
      </AnimatedRoutes>
    </Router>
  )
}

const LoggedOutRouting = (props: { auth: IAuth }) => {
  const [, setProvincia] = useGlobal<IGlobalState, 'prov'>('prov');

  const handleAuthDataLoaded = (authData: AuthDataType) => {
    console.log('AuthData Loaded - from LoggedOutRouting', { authData })
    if (authData.provinciaDefault) {
      setProvincia(authData.provinciaDefault)
    }
  }
  
  return (
    <Router>
      <Switch >
        <Route path="/" exact={true} component={PageLogin}/>
        <Route path="/callback" render={props => <OidcCallback {...props} onAuthDataLoaded={handleAuthDataLoaded} />} />
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>  
    </Router>
  )
}

// const useStylesLogin = makeStyles((theme: Theme) => ({
//   root: {
//       height: '100vh',
//       width: '100vw',
//       top: 0,
//       left: 0,
//       position: 'absolute',
//       backgroundImage: 'linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(\'images/background.jpg\')',
//       backgroundSize: '100vw 100vh',
//       [theme.breakpoints.down('sm')]: {
//           backgroundImage: 'none',
//           backgroundColor: '#eee'
//       }
//   },
// }))

export const PageLogin = () => {
  const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
  const [, setLoadingAuth] = useGlobal<IGlobalState, 'loadingAuth'>('loadingAuth');
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
  let height: string = mobile ? '100%' : '100wh';

  const handleLoginRequest = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    // console.log('Inizio procedura Login');
    setLoadingAuth(true);
    auth.userManager.signinRedirect()
      .then(value => {
        console.log(value);
      })
      .finally(() => {
        // console.log('Login concluso');
      });
  }

  const logoToUse = require(window.location.host.includes("unappa") ? "./images/logo_unappa.png" :
                              window.location.host.includes("wki-") ? "./images/logo_wki.png" : "./images/SixtemaTinexta-Original.png").default;
  return (
    <React.Fragment>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', flex: '0 1 auto', 
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(\'images/background.jpg\')',
            backgroundSize: '100vw 100vh',
            [theme.breakpoints.down('sm')]: {
              backgroundImage: 'none',
              backgroundColor: '#eee'
            }}}
          >
          <div style={{ margin: 'auto', textAlign: 'center', fontSize: '36pt', border: 'solid 1px #c0c0c0', padding: 40, borderRadius: 10, backgroundColor: '#f0f0f0' }}>
            <img style={{ height: '10rem', marginTop: '2rem' }} alt="" src={logoToUse} />
            <Typography variant="h5">{GetConfiguration().title}</Typography>
            <br />
            {sessionStorage.getItem('hideLogin') === '1' ?
              null
            :
            <>
              <Button onClick={handleLoginRequest} type='submit' color='primary' variant='contained'>Login</Button>
            </>
            }
          </div>
        </div>
      {/* <form action="/">
      </form> */}
    </React.Fragment>
  )
}

export default App;